import { Fragment, FC } from "react";
import EventCard from "Components/EventCard";
import { Wrapper } from "./EventList.styled";

interface Props {
  eventList: any;
}

const EventList: FC<Props> = ({ eventList }) => {
  if (!eventList) {
    return null;
  }
  return (
    <Fragment>
      <Wrapper>
        {eventList.length > 0 &&
          eventList?.map((event: any, i: number) => (
            <div key={i}>
              <EventCard event={event} key={i} />
            </div>
          ))}
      </Wrapper>
    </Fragment>
  );
};

export default EventList;
